import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastService} from '../../../main/services';

@Component({
    selector: 'jft-tender-bids',
    templateUrl: './tender-contract-bids.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderContractBidsComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        protected toast: ToastService,
    ) { }

    ngOnInit() {
        //
    }

}
